import { render } from "./harvesterhci.io.addon.vue?vue&type=template&id=3acf334a&scoped=true"
import script from "./harvesterhci.io.addon.vue?vue&type=script&lang=js"
export * from "./harvesterhci.io.addon.vue?vue&type=script&lang=js"

import "./harvesterhci.io.addon.vue?vue&type=style&index=0&id=3acf334a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acf334a"]])

export default __exports__